/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Search_S1Inputs */

const en_lg_search_s1 = /** @type {(inputs: Lg_Search_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose **Search messages** in the chat header, or open the command palette with **Ctrl+K / ⌘K** and choose **Search messages**. A search page opens separately from the chat view.`)
};

const id_lg_search_s1 = /** @type {(inputs: Lg_Search_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih **Cari pesan** pada header chat, atau buka command palette dengan **Ctrl+K / ⌘K** lalu pilih **Cari pesan**. Halaman pencarian terbuka terpisah dari tampilan chat.`)
};

/**
* | output |
* | --- |
* | "Choose **Search messages** in the chat header, or open the command palette with **Ctrl+K / ⌘K** and choose **Search messages**. A search page opens separatel..." |
*
* @param {Lg_Search_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_search_s1 = /** @type {((inputs?: Lg_Search_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Search_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_search_s1(inputs)
	return en_lg_search_s1(inputs)
});